import { UpdatePersonalInfoState } from './updatePersonalInfo.types'

const initialState: UpdatePersonalInfoState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
